import { render, staticRenderFns } from "./Test2.vue?vue&type=template&id=90b6d072&scoped=true&"
import script from "./Test2.vue?vue&type=script&lang=js&"
export * from "./Test2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b6d072",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90b6d072')) {
      api.createRecord('90b6d072', component.options)
    } else {
      api.reload('90b6d072', component.options)
    }
    module.hot.accept("./Test2.vue?vue&type=template&id=90b6d072&scoped=true&", function () {
      api.rerender('90b6d072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/Test2.vue"
export default component.exports